<template>
    <div>
        <h1 style="font-size: 24px; color: black;">变现配置表</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <span> 应用名称： </span>
                    <el-select  v-model="queryData.appId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option
                                v-for="item in appList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <span> 投放媒体： </span>
                    <el-select  v-model="queryData.mediaId" >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="7">
                        <span > 日期：</span>
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="monthrange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始月份"
                                end-placeholder="结束月份"
                                >
                        </el-date-picker>
                </el-col>
                <el-col :span="5">
                    <el-button  type="primary" @click="queryList">查询</el-button>
                    <el-button  type="primary" @click="showDetails('创建')">创建</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px" >
            <el-form :model="form.formData" label-width="150px">
                <el-form-item label="月份时间:" >
                    <el-date-picker style="width: 300px"
                        v-model="form.formData.dt"
                        type="month"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="应用id:" >
                    <el-input  style="width: 300px" type="text" v-model="form.formData.appId"  :disabled="true" ></el-input>
                </el-form-item>
                <el-form-item label="应用名称:" >
                    <el-input  style="width: 300px" type="text" v-model="form.formData.name"  :disabled="true" ></el-input>
                </el-form-item>
                <el-form-item label="应用:" >
                    <el-select  v-model="form.formData.appId" @change="appChange($event)">
                        <el-option
                                v-for="item in appList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务组:" >
                    <el-select  v-model="form.formData.businessGroupId" >
                        <el-option
                                v-for="(value,key) in deptObj"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投放媒体:" >
                    <el-select  v-model="form.formData.mediaId" >
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="主体公司:" >
                    <el-select  v-model="form.formData.subjectCompanyId" >
                        <el-option
                                v-for="(value,key) in companyObj"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款公司:" >
                    <el-select  v-model="form.formData.payCompanyId" >
                        <el-option
                                v-for="(value,key) in companyObj"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算方式:" >
                    <el-select  v-model="form.formData.settlementType" >
                        <el-option
                                v-for="(value,key) in settlementTypes"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算比例:" >
                    <el-input-number style="width: 300px" v-model="form.formData.settlementRate" :precision="2" :step="0.01" ></el-input-number>
                </el-form-item>
                <el-form-item label="是否公摊服务成本:" >
                    <el-radio-group style="width: 300px" v-model="form.formData.bearServicesCost">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="是否摊分奖励金:" >
                    <el-radio-group  style="width: 300px" v-model="form.formData.bearRewards">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                </el-form-item>
                <el-form-item label="状态:" >
                    <el-select  v-model="form.formData.state" >
                        <el-option
                                v-for="(value,key) in states"
                                :label="value"
                                :value="Number(key)"
                                :key="Number(key)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <h1>
            <el-table border :data="topicList"  >
<!--                <el-table-column  label="id"  prop="id" ></el-table-column>-->
                <el-table-column  label="月份时间"  prop="dt" >
                    <template slot-scope="scope">
                        {{ scope.row.dt | dateFormat}}
                    </template>
                </el-table-column>
                <el-table-column  label="应用"  prop="appId" >
                    <template slot-scope="scope">
                        {{ scope.row.appId | commonFilter(appObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="业务组"  prop="businessGroupId" >
                    <template slot-scope="scope">
                        {{ scope.row.businessGroupId | commonFilter(deptObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="投放媒体"  prop="mediaId" >
                    <template slot-scope="scope">
                        {{ scope.row.mediaId | commonFilter(mediaObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="主体公司"  prop="subjectCompanyId" >
                    <template slot-scope="scope">
                        {{ scope.row.subjectCompanyId | commonFilter(companyObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="付款公司"  prop="payCompanyId" >
                    <template slot-scope="scope">
                        {{ scope.row.payCompanyId | commonFilter(companyObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="结算方式"  prop="settlementType" >
                    <template slot-scope="scope">
                        {{ scope.row.settlementType | commonFilter(settlementTypes)}}
                    </template>
                </el-table-column>
                <el-table-column  label="结算比例"  prop="settlementRate" ></el-table-column>
                <el-table-column  label="是否公摊服务成本"  prop="bearServicesCost" >
                    <template slot-scope="scope">
                        {{ scope.row.bearServicesCost | boole}}
                    </template>
                </el-table-column>
                <el-table-column  label="是否摊分奖励金"  prop="bearRewards" >
                    <template slot-scope="scope">
                        {{ scope.row.bearRewards | boole}}
                    </template>
                </el-table-column>
                <el-table-column  label="状态"  prop="state" >
                    <template slot-scope="scope">
                        {{ scope.row.state | commonFilter(states)}}
                    </template>
                </el-table-column>
                <el-table-column  label="最后操作人"  prop="updateUser" >
                    <template slot-scope="scope">
                        {{ scope.row.updateUser | commonFilter(userObj)}}
                    </template>
                </el-table-column>
<!--                <el-table-column  label="创建时间"  prop="createDt" width="160px">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{ scope.row.createDt | dateTimeFormat}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column  label="更新时间"  prop="updateDt" width="160px">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{ scope.row.updateDt | dateTimeFormat}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column  label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[1,10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
       productFlowCashSettingList,
       updateProductFlowCashSetting,
    } from "@/http/financialApi";
    import {states, settlementTypes} from '@/constants/common/basic-data'
    import settingMix from '@/utils/mix/common-setting'
    import DateUtil from '@/utils/DateUtil'
    import objUtil from '@/utils/ObjUtil'
    export default {
        name: "ProductFlowcashSetting",
        mixins: [settingMix],
        data(){
           return{
               page: {
                   size: 20,
                   page: 1,
                   totalElements: null
               },
               dialogVisible: false,
               dialogTitle :'',
               queryData: {
                   appId: -1,
                   mediaId: -1,
                   timeDate: ['', ''],
               },
               topicList:[],
               needGetApp: true,
               appList:[],
               needDept: true,
               deptObj: {},
               needGetMedia: true,
               mediaType: 1,
               mediaObj: {},
               needGetCompany: true,
               companyObj: {},
               needUser: true,
               userObj:{},
               states: states,
               settlementTypes: settlementTypes,
               form: {
                   createData:{
                       "id" : null,
                       "appId" :'',
                       "name" :'',
                       "businessGroupId" :'',
                       "mediaId" :'',
                       "subjectCompanyId" :'',
                       "payCompanyId" :'',
                       "settlementType" :'',
                       "settlementRate" :'',
                       "bearServicesCost" :'',
                       "bearRewards" :'',
                       "updateUser" :'',
                       "createDt" :'',
                       "updateDt" :'',
                       "dt" :'',
                       "state": 1
                   },
                   formData: {},
               }
           }
        },
        methods :{
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList() ;
            },
            appChange(appId) {
                var tempObj=null;
                for (let i = 0; i < this.appList.length; i++) {
                    // console.log(this.appList[i]);
                    if (this.appList[i].appId===appId) {
                        tempObj=this.appList[i];
                        break; //   跳出整个循环
                    }
                }
                this.form.formData.name=tempObj.appName;
            },
            showDetails(title, row) {
                console.log(row);
                this.form.formData = objUtil.clone(this.form.createData)
                this.dialogTitle = title;
                this.dialogVisible = true;
                if(row){
                    this.form.formData = objUtil.clone(row)
                    this.form.formData.bearServicesCost = row.bearServicesCost?1:0
                    this.form.formData.bearRewards = row.bearRewards?1:0
                }
            },
            confirm(){
                updateProductFlowCashSetting(this.form.formData).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryList();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            queryList(){
                let queryTrueData = {appId: this.queryData.appId, mediaId: this.queryData.mediaId}
                console.log(this.queryData.timeDate)
                queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                queryTrueData = Object.assign(queryTrueData, this.page)
                console.log(queryTrueData)
                productFlowCashSettingList(queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                       this.topicList=resp.data.info.content;
                       this.page.totalElements = resp.data.info.total;
                    }
                })
            },
            initDateRange(){
                this.queryData.timeDate = DateUtil.getIntervalMonthWithNoFormat(0)
            }
        },
        created() {
            this.initDateRange()
            this.queryList();
        },
    }
</script>

<style scoped>

</style>
